import { render, staticRenderFns } from "./ResendInvitationSms.vue?vue&type=template&id=0cff5717&scoped=true"
import script from "./ResendInvitationSms.vue?vue&type=script&lang=js"
export * from "./ResendInvitationSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cff5717",
  null
  
)

export default component.exports